import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './features/auth-slice';
import roleReducer from './features/role-slice';
import tenantSlice from './features/tenant-slice';
import commonSlice from './features/common-slice';
import regionSlice from './features/region-slice';
import systemuserSlice from './features/systemuser-slice';
import usersSlice from './features/users-slice';
import languageSlice from './features/language-slice';
import customerSlice from './features/customer-slice';
import masterdataSlice from './features/masterdata-slice';
import imagesSlice from './features/images-slice';
import categorySlice from './features/category-slice';
import configurationSlice from './features/configuration-slice';
import productSlice from './features/product-slice';
import newproductSlice from './features/newproduct-slice';
import ordersSlice from './features/orders-slice';
import dashboardSlice from './features/dashboard-slice';
import datasheetSlice from './features/datasheet-slice';
import collectionSlice from './features/collection-slice';
import newimagesSlice from './features/newimages-slice';
import dealsSlice from './features/deals-slice';
import trackingSlice from './features/tracking-slice';
import holdSlice from './features/hold-slice';
import rewardSlice from './features/reward-slice';

export default combineReducers({
	auth: authReducer,
	role: roleReducer,
	tenant: tenantSlice,
	common: commonSlice,
	regions: regionSlice,
	systemuser: systemuserSlice,
	users: usersSlice,
	language: languageSlice,
	customer: customerSlice,
	master: masterdataSlice,
	image: imagesSlice,
	newimage: newimagesSlice,
	category: categorySlice,
	configuration: configurationSlice,
	product: productSlice,
	newproduct: newproductSlice,
	orders: ordersSlice,
	dashboard: dashboardSlice,
	datasheet: datasheetSlice,
	collection: collectionSlice,
	deals: dealsSlice,
	tracking: trackingSlice,
	hold: holdSlice,
	reward: rewardSlice,
});
